module.exports = __webpack_public_path__ + "static/media/error.cc1213b1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/error.svg
// module id = 122
// module chunks = 36